import { DateTime } from 'luxon';
import z from 'zod';

export const nonEmptyString = z.string().min(1, 'Required');

export const presentOrPastDateSchema = (message?: string, futureDateMessage?: string) =>
  z.iso.date(message).refine((value) => value <= DateTime.now().toISODate(), {
    message: futureDateMessage || 'Date cannot be in the future',
  });
